import {calculationService} from "../../service/calculation-service";

export const namespace = 'cms'

const state = {
  taxRate: 0.1,
  exchangeRate: 0.1,
}

const mutations = {
  initRate(state, payload) {
    Promise.all([
      calculationService.getCountryPolicy$(payload, 'EXCHANGE_RATE').toPromise(),
      calculationService.getCountryPolicy$(payload, 'TAX_RATE').toPromise()
    ]).then(([exchangeRate, taxRate]) => {
      state.exchangeRate = exchangeRate
      state.taxRate = taxRate / 100
    })
  },
  taxRate(state, payload) {
    state.taxRate = payload
  },
  exchangeRate(state, payload) {
    state.exchangeRate = payload
  }
}

const actions = {}

const getters = {
  taxRate(state) {
    return state.taxRate
  },
  exchangeRate(state) {
    return state.exchangeRate
  }
}

export const cmsStore = {
  state,
  mutations,
  actions,
  getters,
  namespace
}
